module.exports = "/fonts/vendor/@fortawesome/fontawesome-pro/webfa-solid-900.ttf?c47cf6d9c8ce96701278f1dcbc6eeb56";